import { render } from "./Prontos.vue?vue&type=template&id=ea9bd19e&scoped=true"
import script from "./Prontos.vue?vue&type=script&lang=js"
export * from "./Prontos.vue?vue&type=script&lang=js"

import "./Prontos.vue?vue&type=style&index=0&id=ea9bd19e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9bd19e"]])

export default __exports__